import type { CreateActivitiesBulk } from './typings'

export const createActivitiesBulkActionCreator = (): CreateActivitiesBulk => ({
  type: 'activities/createActivitiesBulk',
})
